import { render, staticRenderFns } from "./UserGroupComponent.vue?vue&type=template&id=151ad25c&"
import script from "./UserGroupComponent.vue?vue&type=script&lang=js&"
export * from "./UserGroupComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports